import styled from 'styled-components';

export default styled.div`
    background-color: #fcfcfc;
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    padding: 20px;
    border-top: 1px solid #aaaaaa;
    border-radius: 0 0 4px 4px;
`;
